import React from 'react';
import './observacoes.styles.css';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
} from 'reactstrap';
import IntlMessage from '../../../../../helpers/intlMessage';

export const ModalObservacoesPage = (props) => (
  <div className='mv-container-faturamento'>
    <Modal size='lm' isOpen={props.openModal} toggle={props.closeModal}>
      <ModalHeader>{<IntlMessage id = "dashboards.examDetail.comments"/>} - { + props.item.laudo}</ModalHeader>
      <ModalBody>
        <Row>
          <Col>
            <FormGroup className='justificativa'>
              <Label><IntlMessage id = "dashboards.examDetail.reportObservation"/></Label>
              <Input
                type='textarea'
                name='text'
                onChange={(e) =>
                  props.modalOnChangeTexto(e.currentTarget.value)
                }
                disabled={!(props.item.dataLiberacao === '')}
                value={props.texto}
              />
            </FormGroup>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color='secondary' onClick={props.closeModal}>
          <IntlMessage id = "dashboards.examDetails.cancel"/>
        </Button>
        <Button
          color='primary'
          onClick={props.atualizaObservacoes}
          disabled={!(props.item.dataLiberacao === '')}
        >
          <IntlMessage id = "dashboards.examDetail.save"/>
        </Button>
      </ModalFooter>
    </Modal>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/main/listagem/modais/observacoes/modal.observacoes.page.js